<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useGlobalSearch } from './../model/model.ts'

const model = useGlobalSearch()

/**
 * Вычисляем значение иконки платформы
 */
const isMac = computed(() => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return userAgent.includes('mac')
})

onMounted(() => {
  document.addEventListener('keydown', keyDownHandler)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', keyDownHandler)
})

/**
 * Функция обработки нажатия кнопок
 **/
const keyDownHandler = (event: KeyboardEvent) => {
  if (event.code === 'KeyK' && (event.metaKey || event.ctrlKey)) {
    event.preventDefault()

    model.open = !model.open
  }
}
</script>

<template>
  <div class="w-global-search__btn" @click="model.open = true">
    <VIcons type="search" />

    <div class="w-global-search__text">
      {{ $t('itf.search') }}
    </div>

    <div class="w-global-search__key">
      <VIcons v-if="isMac" type="keyboard_command_key" />
      <span class="w-global-search__key-name" v-else>Ctrl</span>
      + K
    </div>
  </div>
</template>
